var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"order-status",class:_vm.type,style:({ color: _vm.color })},[(_vm.type === 'ping')?_c('span',{staticClass:"dot ping-effect",style:({ color: _vm.color })}):_vm._e(),(_vm.type === 'ping')?_c('span',{staticClass:"dot",style:({ color: _vm.color })}):_vm._e(),_vm._v(" "+_vm._s(_vm.displayText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }